const CHANGES_TO_EXCLUDE_FROM_REVERT = [
  'audience',
  'budget',
  'budget_type',
  'daily_spend_cap',
  'geographic.includes',
  'geographic.excludes',
  'status',
  'priority',
  'traffic_filter_eids',
  'traffic_user_targeting_type',
] as const;

export const shouldExcludeChangeFromRevert = (label: string): boolean =>
  CHANGES_TO_EXCLUDE_FROM_REVERT.some(excluded => label.includes(excluded));
